<template>
  <div v-loading="loadingPrescriptionPreview" class="medication-request-preview">
    <h5 class="medication-request-preview__title">
      Visualización de Prescripción
    </h5>
    <div class="medication-request-preview__content">
      <prescription-preview
        :prescription-id="prescriptionId"
        height="100%"
        @prescription-loaded="handlePrescriptionPreviewLoaded" />
    </div>
  </div>
</template>

<script>
import PrescriptionPreview from '@/components/prescription/PrescriptionPreview';
export default {
  name: 'MedicationRequestPreview',
  components: {
    PrescriptionPreview
  },
  data() {
    return {
      loadingPrescriptionPreview: true
    };
  },
  computed: {
    prescriptionId() {
      return this.$route.params.prescriptionId;
    }
  },
  methods: {
    handlePrescriptionPreviewLoaded() {
      this.loadingPrescriptionPreview = false;
    }
  }
};
</script>

<style lang="scss">
.medication-request-preview {
  height: 650px;
  background-color: $--color-white;
  border-radius: $--border-radius-base;
  padding: $--spacing-4;
  margin-top: $--spacing-4;
  display: flex;
  flex-direction: column;

  &__title {
    color: $--color-blue;
    margin: 0 0 $--spacing-4 0;
  }

  .medication-request-preview__content {
    flex: 1;
  }

  .prescription-preview {
    height: 100%;
  }
}
</style>
